<template>
  <div>
    <v-treeview
      :items="tree"
      shaped
      hoverable
      color="primary"
    >
      <template v-slot:prepend="{ item, open }">
        <v-chip
          :color="itemConfig(item, open).color"
          small
          outlined
        >
          <v-icon
            left
            small
          >
            {{ itemConfig(item, open).icon }}
          </v-icon>
          {{ itemConfig(item, open).label }}
        </v-chip>
      </template>

      <template v-slot:label="{ item, open }">
        <span class="subtitle-1 line-height-1">{{ item.name }}</span> <br>
        <span class="caption grey--text">{{ item.description }}</span>
      </template>

      <template v-slot:append="{ item, open }">
        <v-chip
          v-if="item.isArchived && (item.type === 'event' || item.type === 'complete_event')"
        >
          <v-icon>archive</v-icon>
          Archived
        </v-chip>
        <v-chip
          v-if="!item.isActive && (item.type === 'event' || item.type === 'complete_event')"
          text
          small
          outlined
        >
          <v-icon
            :left="$vuetify.breakpoint.mdAndUp"
            small
          >
            pause
          </v-icon>
          <span v-if="$vuetify.breakpoint.mdAndUp">Paused</span>
        </v-chip>
        <event-menu
          v-if="item.type === 'event' || item.type === 'complete_event'"
          :type="item.type"
          :event="item"
          :num-children="item.children.length"
        />
        <event-item-task-menu
          v-if="item.type === 'task'"
          :event-item="item"
        />
        <event-item-alert-menu
          v-if="item.type === 'alert'"
          :event-item="item"
        />
        <event-group-menu
          v-if="item.type === 'group'"
          :event-id="item.eventId"
          :event-group="item"
          :num-children="item.children.length"
        />
      </template>
    </v-treeview>
  </div>
</template>
<style>
  .line-height-1 {
    line-height: 1 !important;
  }

  .no-line-height, .v-treeview-node__label {
    line-height: 0px !important;
  }
</style>
<script>
import { mapGetters } from 'vuex'
import EventMenu from "./EventTreeMenus/EventMenu"
import EventItemTaskMenu from "./EventTreeMenus/EventItemTaskMenu"
import EventItemAlertMenu from "./EventTreeMenus/EventItemAlertMenu"
import EventGroupMenu from "./EventTreeMenus/EventGroupMenu"


export default {
  components: {
    EventMenu,
    EventItemTaskMenu,
    EventItemAlertMenu,
    EventGroupMenu
  },
  computed: {
    ...mapGetters([ 'eventTree' ]),
    tree() {
      return this.eventTree
    }
  },
  methods: {
    itemConfig(item, open) {
      const iconMap = {
        task: 'done_outline',
        alert: 'notifications_none',
        group: open ? 'folder_open' : 'folder',
        event: 'flash_on',
        complete_event: 'flash_on'
      }

      const colorMap = {
        task: 'primary',
        alert: 'red accent-2',
        group: 'grey',
        event: 'success',
        complete_event: 'success'
      }

      const labelMap = {
        task: 'task',
        alert: 'alert',
        group: 'group',
        event: 'event',
        complete_event: 'complete event'
      }

      const icon = item.type in iconMap
        ? iconMap[ item.type ]
        : ''

      const color = item.type in colorMap
        ? colorMap[ item.type ]
        : ''

      const label = item.type in labelMap
        ? labelMap[ item.type ].toUpperCase()
        : ''

      return { icon, color, label }
    },
  },
}
</script>
